module.exports = __webpack_public_path__ + "img/case3.b9283509.jpg";